module.exports = __webpack_public_path__ + "media/images/responsive/flow/waso_step01-ef6faaedf029e2dd7ed68b155169b3d8.jpg";